// removed by extract-text-webpack-plugin
module.exports = {"faqs":"faqs__3uwzH","group":"group__3rZCf","groupMandate":"groupMandate__3X-2S","question":"question__2RyzC","questionMandate":"questionMandate__1FlEw","answer":"answer__25cIc","read-more":"read-more__3FPA7","mandate":"mandate__1N9Gi","FAQ-mandate-heading":"FAQ-mandate-heading__2ZOd1"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/faq.scss
// module id = 610
// module chunks = 68